const API_ENDPOINT_URL = 'https://l6tmgftb3j.execute-api.ap-northeast-1.amazonaws.com/v1';

export const config = {
    api: {
        invokeUrl: API_ENDPOINT_URL,
    },
};